








































































































































































































































/* 
  getParam 获取统计页面参数
  getEmployInfo 获取评卷聘用信息查询分页列表
  applyReplace 申请更换
  printOffer 打印聘书
*/
import { Vue, Component } from "vue-property-decorator";
//引入接口调用函数
import {
  getParam,
  getEmployInfo,
  applyReplace,
  cancelApplyReplace,
  printOffer
} from "../../../api/employInfoSearch";
import {
  printContract
} from "../../../api/markingTeacherEvaluate";
//引入导入、导出、下载的处理函数
import importAndExportMixin from "../../../mixins/importAndExport";

//自定义的form对象接口
interface CustomForm {
  [propName: string]: any;
}

@Component({
  name: "markingEmployManage",
  mixins: [importAndExportMixin]
})
export default class extends Vue {
  private projectId: string = ""; //项目
  private projectLabel: string = ""; //项目展示标签
  private isApply: string = ""; //是否申请
  private teacherName: string = ""; //评卷教师
  private showTableLoading: boolean = false; //是否显示列表loading
  private tableData: object[] = []; //列表数据
  private pageNo: number = 1; //当前页码
  private pageSize: number = 10; //当前条目
  private total: number = 0; //总条数
  private chooseIdArray: string[] = []; //勾选的数据id集合
  private chooseRowArray: object[] = []; //勾选的数据row 集合
  private showContract: boolean = false; //是否显示"聘书"弹窗
  private showApplyChange: boolean = false; //是否显示“申请更换”弹窗
  private applyChangeForm: CustomForm = {}; //"申请更换"弹窗的数据
  private applyType: string | number = 0; // 申请更换 0  取消申请更换 1
  private currentInfo: CustomForm = {}; //当前勾选的单条数据（打印聘书窗口的数据）
  private employState: string = "" //是否聘用
   private isExcellent:string = "" //是否优秀教师
  //页面参数
  private projects: object[] = []; //项目数组
  private fullscreenLoading: boolean = false; //spin toggle
  private showAdvancedSearch: boolean = false; //是否显示高级筛选
  private tableHeight: number = 0;
  public $refs!: {
    table: HTMLFormElement;
  };
  private iframe:any = null  //装载pdf的iframe对象
  private breadcrumbName = '' //当前打印按钮名称
  private showPdfLoading = false
  created() {
    //初始化data数据
    this.initDta();
    //获取页面参数
    this.getParams();
    //获取列表
    this.getData();
  }

  mounted() {
    setTimeout(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 80;
      if (this.tableHeight < 300) { this.tableHeight = 300; }
    }, 100);
  }

  beforeDestroy() {
    // 释放文件引用
    if (this.iframe && this.iframe.src) {
      window.URL.revokeObjectURL(this.iframe.src);
    }
  }

  initDta() {
    const { projectLabel, projectId } = this.$route.query;
    if (projectLabel && projectId) {
      this.projectId = projectId as string;
      this.projectLabel = projectLabel as string;
    }
  }

  // 根据分页计算页码
  private indexMethod(index) {
    return index + 1 + (this.pageNo - 1) * this.pageSize;
  }

  //获取页面参数
  private async getParams() {
    try {
      let res = await getParam();
      this.projects = res.data;
    } catch (error) {
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //getEmployInfo 和 exportEmployInfo 接口的参数
  private getRequestParams() {
    return {
      current: this.pageNo, //当前页
      size: this.pageSize, //记录数
      employApplyState: this.isApply, //是否申请 0:否 1:是
      projectId: this.projectId, //项目id
      teacherName: this.teacherName, //教师姓名
      employState:this.employState, //聘用状态
      otherinfoIsExcellentTeacher:this.isExcellent //优秀教师
    };
  }

  //获取列表数据
  private async getData() {
    this.showTableLoading = true;
    try {
      let res = await getEmployInfo(this.getRequestParams());
      this.showTableLoading = false;
      this.tableData = res.data.records;
      this.total = res.data.total;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //搜索查询
  private searchHandle() {
    this.pageNo = 1;
    this.getData();
  }

  //重置搜索条件
  private resetSearch() {
    this.projectId = "";
    this.employState = "";
    this.isApply = "";
    this.teacherName = "";
    this.isExcellent = "";
    this.pageNo = 1;
    this.getData();
  }

  //勾选处理
  private selectChangeHandle(v: object[]) {
    //记录勾选时的单条数据
    this.currentInfo = v[0];
    //保存勾选的教师id
    this.chooseIdArray = v.map((item: any) => {
      return item.teacherId;
    });
    // 勾选的单行的内容 -- 用于打印优秀证书
    this.chooseRowArray = [...v];
  }
  //返回列表页
  private goBack(){
    // 释放文件引用
    if (this.iframe && this.iframe.src) {
      window.URL.revokeObjectURL(this.iframe.src);
    }

    this.$refs['iframeContainer'].removeChild(this.iframe);
    this.iframe = null
  }

//预览pdf
 private previewPDF(res){
    //创建一个iframe
    this.iframe = document.createElement("iframe");
    this.iframe.setAttribute("frameborder", 0);
    this.iframe.style.width = "100%";
    this.iframe.style.height = "100%";
    this.$refs['iframeContainer'].appendChild(this.iframe);
    this.iframe.src = window.URL.createObjectURL(res);
  }
  //清空表格选中
  private clearSelection(){
    this.$refs['table'].clearSelection()
  }

  //“打印聘书”处理
  private async printHandle(type) {
    if (this.chooseIdArray.length <= 0) {
      this.$message.warning("请勾选一条记录！");
      return false;
    }
    // if(this.chooseRowArray.length > 1) {
    //    this.$message.error("最多勾选一条记录！");
    //   return false;
    // }
  //  let params: object = {
  //   projectId:  this.chooseRowArray[0][`projectId`], // 项目id
  //   teacherId:  this.chooseRowArray[0][`teacherId`] // 教师id
  // }
  let arr = this.chooseRowArray.map(item=>{
    return {
      projectId:  item[`projectId`], // 项目id
      teacherId:  item[`teacherId`], // 教师id
      subjectId: type === 'employ' ? item[`subjectId`] : undefined
    }
  })
  // params = type === 'employ' ? {...params, subjectId: this.chooseRowArray[0][`subjectId`] } : params;
  this.breadcrumbName = type === 'employ' ? '打印聘书' : '打印优秀证书'
  let url = type === 'employ' ? printOffer : printContract;
  try{
     this.showPdfLoading = true
     let res = await url(arr);
     this.showPdfLoading = false
     this.clearSelection() //清空选择
     this.previewPDF(res) //预览pdf
  }
  catch(error){   
      this.showPdfLoading = false
      this.clearSelection() //清空选择
      // this.$message.error(error || "操作失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
  }
  }

  //关闭聘书处理
  private closeContract() {
    this.showContract = false;
    //刷新列表
    this.getData();
  }
  // 打印 方法
  private async chooseDownloadHandle(res, fileFullName) {
    try {
      const blob: Blob = new Blob(
        [res],
        {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
        }
        // {type: 'application/pdf;charset=UTF-8'}
      );
      const patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
      const downloadElement = document.createElement("a");
      const href = window.URL.createObjectURL(blob); // 创建下载的链接
      downloadElement.style.display = "none";
      downloadElement.href = href;
      downloadElement.download = fileFullName; // 下载后文件名 单位管理模板.xlsx
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
      window.URL.revokeObjectURL(href); // 释放掉blob对象
      this.$message.success("下载成功");
    } catch (error) {
      // this.$message.error(error || "下载失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //“申请更换”处理
  private applyChange(type: any) {
    if (this.chooseIdArray.length !== 1) {
      this.$message.warning("请勾选一条记录！");
      return false;
    }
    this.applyChangeForm = {
      teacherName: this.currentInfo.teacherName, //教师姓名
      applyReason: this.currentInfo.employApplyReason, //申请理由
      projectId: this.currentInfo.projectId, //项目id
      subjectId: this.currentInfo.subjectId, //科目id
      teacherId: this.currentInfo.teacherId //教师id
    };
    this.applyType = type;
    this.showApplyChange = true;
  }

  //“申请更换”提交处理
  private async saveApplyChange() {
    try {
      if (this.applyType == 0) {
        this.fullscreenLoading = true;
        await applyReplace(this.applyChangeForm);
        this.fullscreenLoading = false;
      }
      if (this.applyType == 1) {
        this.fullscreenLoading = true;
        await cancelApplyReplace(this.applyChangeForm);
        this.fullscreenLoading = false;
      }
      this.$message.success("提交成功");
      //关闭更换窗口
      this.showApplyChange = false;
      //刷新列表
      this.getData();
    } catch (error) {
      this.fullscreenLoading = false;
      // this.$message.error(error || "提交失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //“导出名单”处理
  private exportHandle() {
    (this as any).downloadHandle(
      "exportEmployInfo",
      "聘用信息.xlsx",
      this.getRequestParams()
    );
  }

  // 每页条目变化时
  private handleSizeChange(val: number): void {
    this.pageSize = val;
    this.getData();
  }
  // 当前页发生改变时
  private handleCurrentChange(val: number): void {
    this.pageNo = val;
    this.getData();
  }
}
